import { render, staticRenderFns } from "./restricted.vue?vue&type=template&id=3f7bbac4"
import script from "./restricted.vue?vue&type=script&lang=js"
export * from "./restricted.vue?vue&type=script&lang=js"
import style0 from "./restricted.vue?vue&type=style&index=0&id=3f7bbac4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports